// import React, { useEffect, useState } from "react";
// import { useForm, Controller } from "react-hook-form";
// import LeftSection from "../../Components/Auth/LeftSection";
// import classes from "../../Components/Auth/RightSection.module.css";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { SlArrowLeft } from "react-icons/sl";
// import { useDispatch } from "react-redux";
// import { fetchCart } from "../../Redux/slices/cartSlice";

// export default function Step2() {
//   const navigate = useNavigate();
//   const [mobile, setMobile] = useState("");
//   const [loginFlow, setLoginFlow] = useState(0);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isResendLoading, setIsResendLoading] = useState(false);
//   const [errmessage,seterrmessage]=useState({isError:false,message:""})
//   // useForm for handling OTP input
//   const {
//     handleSubmit,
//     control,
//     watch,
//     formState: { errors },
//   } = useForm();

//   useEffect(() => {
//     setMobile(localStorage.getItem("mmt_login_mobile"));
//   }, []);

//   const dispatch = useDispatch();

//   // Watch all OTP fields
//   const otpValues = watch(["otp1", "otp2", "otp3", "otp4", "otp5", "otp6"]);

//   const resendOtp = () => {
//     setIsResendLoading(true);
//     let otpData = {
//       mobile: mobile,
//     };
//     axios
//       .post(`${process.env.REACT_APP_OTP_URL}otp/generate-otp`, otpData)
//       .then((res) => {
//         //console.log("res", res);
//         setIsResendLoading(false);
//         // alert("OTP has been sent to your mobile number");
//         // localStorage.setItem("mmt_front_accessToken", res.data.response.accessToken);
//         // localStorage.setItem("mmt_front_refreshToken", res.data.response.refreshToken);
//         // navigate("/registration/step2");
//       })
//       .catch((errors) => {
//         setIsResendLoading(false);
//         //console.log(errors);
//       });
//   };

//   const submitData = (data) => {
//     seterrmessage({isError:false, message:""})

//     setIsLoading(true);
//     // Combine OTP values
//     const otp = Object.values(data).join("");
//     //console.log('OTP:', otp);
//     let otpData = {
//       mobile: mobile,
//       otp: otp,
//     };
//     axios
//       .post(`${process.env.REACT_APP_OTP_URL}otp/verify-otp`, otpData)
//       .then((res) => {
//         if (res.data && res.data.result) {
//           let token = res.data.result.response;
//           console.log("res.data",res.data)
//           let user_data={
//             username:res.data.username,
//             company_name:res.data.company_name,
//             gst_number:res.data.gst_number,
//             location:res.data.location,
//             customer_type:res.data.customer_type,
//             user_id:res.data.user_id
//           }
//           localStorage.setItem("mmt_front_token", JSON.stringify(token));
//           localStorage.setItem("user_details", JSON.stringify(user_data));

//           dispatch(fetchCart({ user_id:res.data.user_id }));

//           navigate("/dashboard");

//           // window.location.reload();
//         } else {
//           navigate("/final-registration");
//         }
//         setIsLoading(false);
//       })
//       .catch((errors) => {
//         //console.log(errors.response.status);
//         //  console.log(errors.response.data.message)
//         if (errors?.response?.data?.message == "Invalid OTP.") {
//           // alert("Invalid OTP");
//           console.log('alsdjkf')
//           seterrmessage({isError:true, message:"Invalid OTP. Please enter a valid one."})
//         }
//         if (errors?.response?.data?.message == "Expired OTP.") {
//           // alert("Invalid OTP");
//           console.log('alsdjkf')
//           seterrmessage({isError:true, message:"Your OTP has expired. Please request a new one."})
//         }

//         setIsLoading(false);
//       });
//     // You can proceed with OTP verification here
//   };

//   return (
//     <main>
//       <div className="flex grid-cols-2 justify-center">
//         <div className="w-full">
//           <LeftSection />
//         </div>

//         <div className="w-full">
//           <span
//             onClick={() => navigate("/registration")}
//             className="float-left m-10 text-gray-400 flex gap-2 items-center cursor-pointer"
//           >
//             <SlArrowLeft className="text-xs " /> Back
//           </span>
//           <div className={`p-5 ps-20 py-16 pe-48 ${classes.RhtFormSec}`}>
//             <h2 className="text-xl mb-3 font-semibold">
//               Enter The OTP To Verify Your Account
//             </h2>
//             <p className="mb-10" style={{ color: "#8692A6" }}>
//               Enter the OTP that we sent to your mobile number {mobile}. Be
//               careful not to share the OTP with anyone.
//             </p>

//             <form >
//               <ul className="flex gap-5">
//                 {Array.from({ length: 6 }, (_, index) => (
//                   <li key={index}>
//                     <Controller
//                       name={`otp${index + 1}`}
//                       control={control}
//                       defaultValue=""
//                       rules={{ required: true, minLength: 1, maxLength: 1 }}
//                       render={({ field }) => (
//                         <input
//                           {...field}
//                           type="text"
//                           maxLength="1"
//                           className={`rounded-md border justify-center p-2 flex items-center text-center ${classes.otpBox}`}
//                           style={{ width: "49px", height: "45px" }}
//                           onChange={(e) => {
//                             const { value } = e.target;
//                             field.onChange(e);

//                             // Automatically shift to the next input if current one is filled
//                             if (value.length === 1) {
//                               const nextInput = document.querySelector(
//                                 `input[name=otp${index + 2}]`
//                               );
//                               if (nextInput) {
//                                 nextInput.focus();
//                               }
//                             }
//                           }}
//                           onKeyDown={(e) => {
//                             // Allow backspace to focus on the previous input
//                             if (e.key === "Backspace" && field.value === "") {
//                               const prevInput = document.querySelector(
//                                 `input[name=otp${index}]`
//                               );
//                               if (prevInput) {
//                                 prevInput.focus();
//                               }
//                             }
//                           }}
//                         />
//                       )}
//                     />
//                     {/* {errors[`otp${index + 1}`] && (
//                       <span className="text-red-600">Required</span>
//                     )} */}
//                   </li>
//                 ))}
//               </ul>

//               <div
//                 className="mt-3 text-center w-full"
//                 style={{ color: "#696F79" }}
//               >
//                 Didn’t Get The OTP?{" "}
//                 <button
//                   onClick={resendOtp}
//                   className="underline cursor-pointer"
//                   style={{ color: "#A80000" }}
//                   disabled={isResendLoading}
//                 >
//                   {isResendLoading ? "Resending..." : "Click to resend"}
//                 </button>
//               </div>

//               {errmessage.isError && <div
//                  className="mt-3 text-center w-full"
//                  style={{ color: "#A80000" }}
//                 >
//                 <p className="text-muted body2">{errmessage.message}</p>
//                 </div>}

//               {/* <input
//                 type="submit"
//                 className="w-full main-color p-5 rounded-lg text-white mt-7 cursor-pointer"
//                 value={isLoading ? "Verifying..." : "Verify OTP"}
//                 disabled={isLoading}
//               /> */} <button
//                 type="submit"
//                 className={`w-full ${
//                   isLoading ? "secondary-color" : "main-color"
//                 } p-5 rounded-lg text-white mt-5 cursor-pointer flex items-center justify-center`}
//                 disabled={isLoading}
//                 onClick={handleSubmit(submitData)}

//               >
//                 {isLoading ? (
//                   <div className="flex items-center gap-2">
//                     <svg
//                       className="animate-spin h-5 w-5 text-white"
//                       xmlns="http://www.w3.org/2000/svg"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                     >
//                       <circle
//                         className="opacity-25"
//                         cx="12"
//                         cy="12"
//                         r="10"
//                         stroke="currentColor"
//                         strokeWidth="4"
//                       ></circle>
//                       <path
//                         className="opacity-75"
//                         fill="currentColor"
//                         d="M4 12a8 8 0 018-8v8H4z"
//                       ></path>
//                     </svg>
//                     <span>Verifying...</span>
//                   </div>
//                 ) : (
//                   "Verify OTP"
//                 )}
//               </button>
//             </form>
//           </div>
//         </div>
//       </div>
//     </main>
//   );
// }

import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import LeftSection from "../../Components/Auth/LeftSection";
import classes from "../../Components/Auth/RightSection.module.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { SlArrowLeft } from "react-icons/sl";
import { useDispatch } from "react-redux";
import { fetchCart } from "../../Redux/slices/cartSlice";
import logo from "../../Assets/MMT_Green_Black.png";

export default function Step2() {
  const navigate = useNavigate();
  const [mobile, setMobile] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isResendLoading, setIsResendLoading] = useState(false);
  const [errmessage, setErrMessage] = useState({ isError: false, message: "" });
  const {
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();

  useEffect(() => {
    setMobile(localStorage.getItem("mmt_login_mobile"));
  }, []);

  const otpValues = watch(["otp1", "otp2", "otp3", "otp4", "otp5", "otp6"]);

  const resendOtp = () => {
    setIsResendLoading(true);
    axios
      .post(`${process.env.REACT_APP_OTP_URL}otp/generate-otp`, { mobile })
      .then(() => setIsResendLoading(false))
      .catch(() => setIsResendLoading(false));
  };

  const submitData = (data) => {
    setErrMessage({ isError: false, message: "" });
    setIsLoading(true);

    const otp = Object.values(data).join("");
    axios
      .post(`${process.env.REACT_APP_OTP_URL}otp/verify-otp`, { mobile, otp })
      .then((res) => {
        const { result } = res.data;
        if (result) {
          const token = result.response;
          const user_data = {
            username: res.data.username,
            company_name: res.data.company_name,
            gst_number: res.data.gst_number,
            location: res.data.location,
            customer_type: res.data.customer_type,
            user_id: res.data.user_id,
          };
          localStorage.setItem("mmt_front_token", JSON.stringify(token));
          localStorage.setItem("user_details", JSON.stringify(user_data));
          dispatch(fetchCart({ user_id: res.data.user_id }));
          navigate("/dashboard");
        } else {
          navigate("/final-registration");
        }
        setIsLoading(false);
      })
      .catch((err) => {
        const errorMsg = err?.response?.data?.message;
        if (errorMsg === "Invalid OTP.") {
          setErrMessage({
            isError: true,
            message: "Invalid OTP. Please enter a valid one.",
          });
        } else if (errorMsg === "Expired OTP.") {
          setErrMessage({
            isError: true,
            message: "Your OTP has expired. Please request a new one.",
          });
        }
        setIsLoading(false);
      });
  };

  return (
    <main className="flex flex-col md:flex-row min-h-screen">
      {/* Left Section */}
      <div className="hidden md:block w-1/2">
        <LeftSection />
      </div>

      {/* Right Section */}
      <div className="w-full md:w-1/2 flex flex-col items-center justify-center p-6 bg-gray-50 relative">
       

        {/* Back Button */}
        <span
          onClick={() => navigate("/registration")}
          className="absolute top-6 left-4 text-gray-500 flex gap-2 items-center cursor-pointer"
        >
          <SlArrowLeft className="text-base" /> Back
        </span>

        {/* Form Section */}
        <div className="w-full max-w-sm flex flex-col items-center justify-center min-h-screen md:min-h-[auto]">
          
        {/* <div className={`p-5 lg:py-16 lg:px-20 ${classes.RhtFormSec} mt-20`}> */}
           {/* Logo */}
        <div className="w-full max-w-sm mb-8 md:hidden  flex justify-center">
          <img
            src={logo}
            alt="Logo"
            className={classes.logoImage}
          />
        </div>
          <h2 className="text-2xl lg:text-3xl font-semibold mb-4 text-center">
            Verify Your Account
          </h2>
          <p className="text-sm lg:text-base text-gray-500 mb-8 text-center">
            Enter the OTP sent to your mobile number {mobile}. Don’t share it
            with anyone.
          </p>

          {/* OTP Form */}
          <form onSubmit={handleSubmit(submitData)} className="space-y-6">
            <div className="flex justify-center gap-3">
              {Array.from({ length: 6 }, (_, index) => (
                <Controller
                  key={index}
                  name={`otp${index + 1}`}
                  control={control}
                  defaultValue=""
                  rules={{ required: true }}
                  render={({ field }) => (
                    <input
                      {...field}
                      type="text"
                      maxLength="1"
                      className={`w-12 h-12 border rounded-md text-center ${classes.otpBox}`}
                      onChange={(e) => {
                        const nextInput = document.querySelector(
                          `input[name=otp${index + 2}]`
                        );
                        if (e.target.value && nextInput) nextInput.focus();
                        field.onChange(e);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Backspace" && !field.value) {
                          const prevInput = document.querySelector(
                            `input[name=otp${index}]`
                          );
                          if (prevInput) prevInput.focus();
                        }
                      }}
                    />
                  )}
                />
              ))}
            </div>

            {/* Resend OTP */}
            <div className="text-center">
              <span className="text-gray-500">Didn’t get the OTP? </span>
              <button
                onClick={resendOtp}
                type="button"
                className="text-red-500 underline"
                disabled={isResendLoading}
              >
                {isResendLoading ? "Resending..." : "Click to resend"}
              </button>
            </div>

            {/* Error Message */}
            {errmessage.isError && (
              <p className="text-red-500 text-center">{errmessage.message}</p>
            )}

            {/* Submit Button */}
            <button
              type="submit"
              className={`w-full py-3 rounded-md text-white ${
                isLoading ? "secondary-color" : "main-color"
              } flex items-center justify-center`}
              disabled={isLoading}
            >
              {isLoading ? (
                <span className="flex items-center gap-2">
                  <svg
                    className="animate-spin h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v8H4z"
                    ></path>
                  </svg>
                  Verifying...
                </span>
              ) : (
                "Verify OTP"
              )}
            </button>
          </form>
        {/* </div> */}
        </div>

      </div>
    </main>
  );
}




